(function () {
    'use strict';

    var grid = document.querySelector('[data-lpg]');
    if (!grid) return;

    /* Same unlock-modal contract as content-feed.js: reveal #unlockModal
     * (falling back to #signupModal / .auth-popup / on-page trigger). */
    function openUnlock() {
        var modal = document.getElementById('unlockModal')
            || document.getElementById('signupModal')
            || document.querySelector('.auth-popup');
        if (modal) {
            modal.classList.remove('modal-hidden');
            modal.style.display = 'flex';
            return true;
        }
        var trigger = document.querySelector('.open-signup-modal a, a.open-signup-modal, .open-signup-modal');
        if (trigger) {
            trigger.click();
            return true;
        }
        return false;
    }

    /* Non-members: intercept "Read for free" buttons and gated card links. */
    grid.addEventListener('click', function (e) {
        var target = e.target.closest('[data-lpg-unlock]');
        if (!target || !grid.contains(target)) return;
        e.preventDefault();
        openUnlock();
    });
})();
